// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zZ9K","col":"styles_col__33dZp"};